import { defineMessages } from 'react-intl';

export default defineMessages({
  expiredPasswordResetHeading: {
    id: 'accountSignin.expiredPasswordReset.heading',
    description: 'Heading for validate forgot password reset',
    defaultMessage: 'Forgot password link expired',
  },
  expiredPasswordResetMessage: {
    id: 'accountSignin.expiredPasswordReset.Message',
    description: 'Message for expired forgot password reset',
    defaultMessage:
      'If you’d still like to reset your password, we can send you another link.',
  },
});
